<template>
  <div>
    <v-container>
      <v-row class="mb-4 mt-4">
        <v-col>
          <div>
            <p class="display-1 font-weight-light primary--text">Decline Request</p>
          </div>
        </v-col>
      </v-row>

      <v-row class="mb-4 mt-4">
        <v-col class="d-flex" cols="12">
          <p class="title" :class="{ 'primary--text': !isSummaryView }">
            <span class="font-weight-black">
              {{ optout.question }}
            </span>
          </p>
        </v-col>
        <v-col class="d-none d-sm-flex" cols="6">
          <v-select :items="optout.options" v-model="optOutReason" outlined></v-select>
        </v-col>
        <v-col class="d-flex d-sm-none " cols="12">
          <v-select :items="optout.options" v-model="optOutReason" outlined></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-4 mt-4" v-if="isOtherSelected">
        <v-col>
          <div class="mt-0">
            <p class="title" :class="{ 'primary--text': !isSummaryView }">
              <span class="font-weight-black">
                {{ optout.verbatim.question }}
              </span>
            </p>
            <v-textarea
              v-model="verbatimResponse"
              :rules="[
                v =>
                  currentStep !== this.$props.pageNr ||
                  (!!v && v.length > 0) ||
                  'Please share your comments.'
              ]"
              required
              outlined
            >
            </v-textarea>
          </div>
        </v-col>
      </v-row>

      <v-row class="mb-4 mt-4">
        <v-col>
          <div>
            <v-btn large class="font-weight-black submit" color="#7823dc" @click="optOut">
              Decline
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OptOut',

  components: {},

  data: () => ({
    isOtherSelected: false,
  }),

  props: ['optout', 'pageNr', 'isSummaryView'],

  computed: {
    ...mapGetters(['currentStep', 'surveyFlow', 'isSelfSurvey']),
    params() {
      return this.$store.state.params;
    },
    optOutReason: {
      get() {
        return this.$store.state.response[`${this.optout.field}`];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: 'IsCompleted',
          v: 'true',
        });

        this.$store.commit('storeResponse', {
          k: 'IsOptedOut',
          v: 'true',
        });

        this.$store.commit('storeResponse', {
          k: `${this.optout.field}`,
          v: newValue,
        });
        this.isOtherSelected = newValue === 'Other';
        if (!this.isOtherSelected) {
          this.verbatimResponse = '';
        }
      },
    },
    verbatimResponse: {
      get() {
        return this.$store.state.response[`${this.optout.verbatim.field}`];
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: `${this.optout.verbatim.field}`,
          v: newValue,
        });
      },
    },
  },

  methods: {
    optOut() {
      this.$store.commit('setCurrentStep', this.surveyFlow.length);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      this.$store.dispatch('storeResponse');
    },
  },
};
</script>

<style scoped>
.submit {
  margin-bottom: 5px;
  border-color: #7823dc;
  color: white !important;
}
</style>
